import React from "react";
import './Body12.css';
import picture150 from './source/picture150.png'
import picture151 from './source/picture151.png'
import picture152 from './source/picture152.png'





function Body12() {

  return (
    <div className="body12">
      <div className="body12-box1">
        <div className="body12-box2">
          <div className="body12-box3">Certifikáty</div>
          <div className="body12-box5"><div className="body12-box4"></div></div>
          <div className="body12-box6">
          <img className="body12-box6-picture" src={picture150} alt="picture1"/>
          <img className="body12-box6-picture" src={picture151} alt="picture1"/>
          <img className="body12-box6-picture" src={picture152} alt="picture1"/>

          </div>
        </div> 
      </div> 
    </div>
  );
}

export default Body12;
